
    <button type="button" class="btn btn-primary btn-sm" (click)="view()" style="font-size: 12px;width: 70px;"> <i class="far fa-file"></i> View 
    </button>
    &nbsp;&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="print()" style="font-size: 12px;width: 70px;"> <i class="far fa-file-pdf"></i> Print
    </button>
    &nbsp;&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="delete()" style="font-size: 12px;width: 70px;"> <i class="far fa-minus"></i> Delete
    </button>